module.exports = __webpack_public_path__ + "img/logo-ans.475c1a77.png";